import { useFormContext } from "react-hook-form";
import { usePunditUserContext } from "@/react/contexts";
import { DependentFields } from "./DependentFields";
import { IosAppEnabledField } from "./IosAppEnabledField";

export const MobileAppFormFields = () => {
  const { currentCommunity } = usePunditUserContext();
  const { watch } = useFormContext();
  const iosAppEnabled = watch("community_setting.ios_app_enabled");

  return (
    <div className="mb-8">
      <IosAppEnabledField />
      <DependentFields
        iosAppEnabled={iosAppEnabled}
        hasBrandedApp={!!currentCommunity?.has_branded_app}
      />
    </div>
  );
};
